import { http } from "./http";

export const onlineApi = {
  list(params = {}) {
    return http.get("/api/admin/online", { params }).then((r) => r.data);
  },
};
